export default __webpack_public_path__ + "static/media/chocolate-wallpaper-1.436b006e.jpg";